import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import GigsTable from '../../components/Tables/GigsTable'

const Gigs = () => {
    return (

        <AdminSidebarLayout currentPath="/gigs">
            <div className="bg-[#F5F5F5] dark:bg-[#0b0e14] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <GigsTable/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default Gigs